<template>
    <div class="ba6-user-storage">
        <p v-text="t.label_storage_warning_24_hours"></p>
        <div class="ba6-us-main">
            <radial-progress-v3
                :options="{
                    color :     'var(--theme-color-accent)',
                    step  :      storage.storage_percent,
                    background: 'var(--theme-color-primary)',
                    percent:     true
                }">
            </radial-progress-v3>
            <div class="ba6-us-main-vertical-line" />
            <div class="ba6-us-main-info">
                <div class="ba6-us-mi-element">
                    <div class="ba-flex ba-gp-1 ba-ai-center">
                        <i><builderall-icon code='clickmap'></builderall-icon></i>
                        <span class="ba6-text-info" v-text="t.storage_available"></span>
                    </div>
                    <span class="ba6-text-data" v-text="storage.storage_available + 'GB'"></span>
                </div>
                <div class="ba6-us-main-horizontal-line" />
                <div class="ba6-us-mi-element">
                    <div class="ba-flex ba-gp-1 ba-ai-center">
                        <i><builderall-icon code='clickmap'></builderall-icon></i>
                        <span class="ba6-text-info" v-text="t.dns_in_use"></span>
                    </div>
                    <span class="ba6-text-data" v-text="storage.storage_used + 'GB'"></span>
                </div>
            </div>
        </div>
        <button class="ba6-view-details-btn" @click="viewStorageDetails()" v-text="t.view_more_details"></button>
        <ba6-modal modal-id="ba6-storage-details">
            <div class='ba-card ba-w-100 ba-no-shadow'>
                <div class='ba-top'>
                    <span class='ba-title' v-text="t.storage_details_title"></span>
                    <div class='ba-box-items ba-flex ba-gp-1'>
                        <button class='ba-btn ba-btn-close ba-sm ba-rounded' @click="toggleModal('ba6-storage-details')">
                            <builderall-icon code='64f7' />
                        </button>
                    </div>
                </div>
                <div class='ba-content ba-w-100 ba-flex ba-f-column ba-gp-2 ba-ai-center'>
                    <table class="ba6-storage-details-table ba-lines-all ba-table ba-md ba-w-100">
                        <thead>
                            <tr>
                                <th>App</th>
                                <th v-text="t.dns_in_use"></th>
                                <th v-text="t.percentage"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(detail,i) in storageDetails" :key="i">
                                <td v-html="detail.app"></td>
                                <td v-text="detail.use + ' Mb'"></td>
                                <td v-text="detail.percent + '%'"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </ba6-modal>
    </div>
</template>

<script>
export default {
  name: "ba6-user-storage",
  props: ['routes', 'storage', 't'],
  data() {
    return {
        loadingStorageDetails: false,
        storageDetails: []
    }
  },
  methods: {
    toggleModal(data){
        $(`#${data}`).toggle('show');
    },
    viewStorageDetails(){
        this.toggleModal('ba6-storage-details');
        this.loadingStorageDetails = true;

        axios
            .get(this.routes.rota_office_storage_details)
            .then((resposta) => {
                if(resposta.data.success)
                {
                    this.storageDetails = resposta.data.details;
                }
                else
                {
                    alertMsg("error",resposta.data.message);
                }
            })
            .catch((error) => {
                console.error('Error to get storage details', error);
            })
            .finally(() => {
                this.loadingStorageDetails = false;
            });
    },
  }
}
</script>

<style scoped lang="scss">
    .ba6-user-storage{
        display: grid;
        gap: 1rem;
        p{
            color: #4D5D71;
            font-size: 12px;
            font-weight: 500;
            letter-spacing: 0.66px;
        }
        .ba6-view-details-btn{
            color: #0072E1;
            font-size: 14px;
            font-weight: 500;
            text-decoration: underline;
            background: none;
            border: none;
            text-align: right;
        }
        .ba6-us-main{
            display: grid;
            gap: 4rem;
            align-items: center;
            grid-template-columns: auto auto 1fr;
            .ba6-us-main-vertical-line{
                height: 166px;
                background-color: #C4D1E0;
                width: 1px;
            }
            .ba6-us-main-info{
                display: flex;
                flex-direction: column;
                gap: 1rem;
                align-items: flex-end;
                .ba6-us-mi-element{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 1rem;
                    width: 100%;
                    i{
                        background-color: #D4DFF5;
                        border-radius: 50%;
                        width: 33px;
                        height: 33px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        builderall-icon{
                            --builderall-icon-size: 22px;
                            --builderall-icon-color: #0072E1;
                        }
                    }
                    .ba6-text-info{
                        color: #8D9EB5;
                        font-size: 12px;
                        font-weight: 500;
                    }
                    .ba6-text-data{
                        color: #4D5D71;
                        font-size: 44px;
                        font-weight: 600;
                        margin-left: 1rem;
                    }
                }
                .ba6-us-main-horizontal-line{
                    background-color: #C4D1E0;
                    width: 100%;
                    height: 1px;
                }
            }
        }
        .ba6-storage-details-table{
            tbody{
                tr:not(:last-child){
                    td:not(:first-child){
                        color: #8D9EB5;
                        font-weight: 500;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/office-v6/account-settings/components/UserStorage.vue